import React, { useRef, useEffect } from 'react'
import classnames from 'classnames';

import styles from './index.less'

function PageVisible(props) {
  const {
    visible,
    children,
  } = props
  // 多 tab 共用同一个 #pages 滚动容器(overflow:auto)。本页可见时持续记录滚动位置,
  // 切走(display:none)再切回时恢复,避免「跳到别的 tab 再回本页被重置到顶部」。
  const savedScroll = useRef(0)

  useEffect(() => {
    if (!visible) return
    const scroller = document.getElementById('pages')
    if (!scroller) return
    // 切回本页:等布局(本页 display:block 重新撑开高度)后恢复上次位置
    const raf = requestAnimationFrame(() => { scroller.scrollTop = savedScroll.current })
    const onScroll = () => { savedScroll.current = scroller.scrollTop }
    scroller.addEventListener('scroll', onScroll, { passive: true })
    return () => {
      cancelAnimationFrame(raf)
      scroller.removeEventListener('scroll', onScroll)
    }
  }, [visible])

  return (
    <div className={classnames(styles.container, {
      [styles.hide]: !visible
    })}>{children}</div>
  )
}

export default PageVisible
